<template>
  <page-view title="我的经办">
    <a-card class="mb-3">
      <a-form-model class="exi_form v2"
                    ref="form" :label-col="{ flex: '0 0 auto' }" :wrapper-col="{ span: 24 }">
        <a-form-model-item label='标题' style="width: 600px">
          <a-input v-model="queryForm.title"/>
        </a-form-model-item>
        <a-button type="primary" @click="onSearch">查询</a-button>
        <a-button style="margin-left: 8px" @click="() => queryForm = {}">重置</a-button>
      </a-form-model>
    </a-card>
    <a-card>
      <s-table
          ref="table"
          :columns="columns"
          :data="loadData"
          :rowKey="record => record.case_id">
        <template slot="title" slot-scope="record">
          <a @click="onView(record)">{{ record.title }}</a>
        </template>
        <template slot="xwfstage" slot-scope="record">
          <div v-html="record.hint"></div>
        </template>
      </s-table>
    </a-card>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import qs from 'qs'

export default {
  name: 'WorkflowPass',
  components: {
    PageView,
    STable
  },
  mounted () {
    this.onFetch()
  },
  data () {
    return {
      columns: [
        { title: '类别', width: '160px', dataIndex: 'cate_name' },
        { title: '项目名称', scopedSlots: { customRender: 'title' } },
        { title: '办理阶段', scopedSlots: { customRender: 'xwfstage' } },
        { title: '当前处理人', width: '160px', dataIndex: 'current_user' },
        { title: '启动时间', width: '160px', dataIndex: 'create_date' },
        { title: '办结时间', width: '160px', dataIndex: 'end_date' }
      ],
      loading: false,
      queryForm: {
        title: null
      },
      queryParam: {},
      loadData: parameter => {
        return this.$http.get('/api/1/workflow/pass_tasks.json?all=1', {
          params: Object.assign(parameter, this.queryParam),
          paramsSerializer: function (params) {
            return qs.stringify(params, { indices: false })
          }
        }).then(res => {
          console.log(res.result)
          for (let i = 0; i < res.result.length; i++) {
            let o = res.result[i]
            if (o.hint == null && o.proc_ins_state === 'A') {
              o.hint = '受理'
            }
            if (o.end_date !== null && o.proc_ins_state !== null) {
              switch (o.proc_ins_state) {
                case 'C':
                  o.hint = '办结'
                  break
                case 'D':
                  o.hint = '归档'
                  break
                case 'T':
                  o.hint = '废弃'
                  break
              }
            }
          }
          return res
        })
      }
    }
  },
  methods: {
    onFetch (params = {}) {
      let that = this
      this.loading = true
      this.$http.get('/api/1/workflow/pass_tasks.json?all=1', {
        params: params,
        paramsSerializer: function (params) {
          return qs.stringify(params, { indices: false })
        }
      }).then(function (response) {
        that.loading = false
        that.data = response.result
      })
    },
    onSearch () {
      if (this.queryForm.title != null) {
        this.queryParam.title = this.queryForm.title
      } else {
        this.queryParam.title = ''
      }
      this.$refs.table.refresh()
    },
    onView (record) {
      let url = record.view_url + '?ifWF=1&id=' + record.case_id
      this.$router.push({ path: url })
    },
    activated () {
      this.onSearch()
    }
  }
}
</script>

<style lang="less" scoped>
.card {
  margin-bottom: 24px;
}
</style>
